import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-call-center',
  templateUrl: './call-center.component.html',
  styleUrls: ['./call-center.component.scss']
})
export class CallCenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  display: boolean = false;
  displayPosition: boolean;

  position: string= "bottomright";

  showDialog() {    
    this.display = true;
  }
}
